import { availableTranslations } from 'todistukset-common/src/vtj/language.util'

export type TodistusKaannosKieli = (typeof availableTranslations)[number]

const isTodistusKaannosKieli = (
  language: unknown
): language is TodistusKaannosKieli => {
  return availableTranslations.some((languageCode) => languageCode === language)
}

/**
 * Checks whether the value is TodistusKaannosKieli
 * @throws if value is not TodistusKaannosKieli
 */
export const toTodistusKaannosKieli = (
  language: unknown
): TodistusKaannosKieli => {
  if (isTodistusKaannosKieli(language)) {
    return language
  }
  throw new Error(`${language} is not TodistusKaannosKieli`)
}
